import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './GridTitle.css';
var GridTitle = function (_a) {
    var children = _a.children;
    return _jsx("h2", { className: styles.subTitle, children: children });
};
export default GridTitle;
